<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
    @click:outside="onCancel"
  >
    <v-card class="px-4 py-4">
      <v-card-title>
        Importação de Resultados
      </v-card-title>
      <v-progress-linear
        v-if="loading"
        color="amber"
        indeterminate
      />
      <v-card-text>
        <v-file-input
          ref="file"
          v-model="files"
          accept=".xlsx, .csv"
          label="Enviar planilha"
        />
      </v-card-text>
      <div class="d-flex justify-space-between">
        <v-btn
          color="primary"
          text
          @click="onCancel"
        >
          fechar
        </v-btn>
        <v-btn
          color="primary"
          text
          @click="onSubmit()"
        >
          Salvar
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import handlesServerValidation from '@/mixins/handles-server-validation.js'
import dayjs from '@/dayjs.js'

export default {
  mixins: [
    handlesServerValidation
  ],

  props: {
    idExam: { type: Number, default: null }
  },

  data: () => ({
    groupSelected: null,
    choiceSelected: null,
    examGroups: [],
    files: [],
    loading: false
  }),
  computed: {
  },
  async mounted () {
    // this.examGroups = await this.$api.getExamGroupQuestionToExport(this.idExam)
  },

  methods: {
    onCancel () {
      this.$emit('resolve', false)
    },

    async onSubmit () {
      this.loading = true

      const formData = new FormData()
      formData.append('file', this.files)
      try {
        const res = await this.$api.triExamImport(this.idExam, formData)
        this.$store.dispatch('setSnackBar', { text: 'planilha importada com sucesso.' })
        this.$emit('resolve', res)
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Ocorreu um erro ao tentar importar planilha.', color: 'red' })
        this.getErrors(e)
      } finally {
        this.loading = false
      }
    },
    dayjs
  }
}
</script>
